import { Seo } from '../components/seo/Seo'
import { NO_ACCOUNT_PROMISE, PERMANENT_FILE_PROMISE } from '../data/siteCopy'

export function AboutPage() {
  return (
    <>
      <Seo route="/about/" />
      <section className="content-hero">
        <div className="shell shell--narrow">
          <p className="eyebrow">About StayInBrowser</p>
          <h1>Everyday tools can keep your data local.</h1>
          <p className="content-hero__lede">StayInBrowser is a growing collection of essential utilities that process files and sensitive inputs on your device.</p>
        </div>
      </section>
      <section className="prose-section">
        <div className="shell shell--narrow prose-grid">
          <div>
            <h2>Why we’re building this</h2>
            <p>Many simple online tasks ask you to upload a file even when modern browsers are capable of processing it locally. That adds exposure, waiting time, and uncertainty without always adding value.</p>
            <p>{NO_ACCOUNT_PROMISE} Public tools open without signing in or providing account credentials; browser-local processing separately keeps files and sensitive tool inputs on your device.</p>
            <p>We want everyday tools to feel polished and straightforward while collecting as little as possible. Today the collection covers images, PDFs, developer and data work, calculators, QR codes, device and media tasks, business documents, text, and private spending—with previews and results created in the page.</p>
          </div>
          <aside className="quote-card">
            <p>“{PERMANENT_FILE_PROMISE}”</p>
            <span>Our product direction, stated plainly.</span>
          </aside>
          <div>
            <h2>How we choose tools</h2>
            <p>A tool belongs here when it solves a real task, provides a clear experience on mobile and desktop, and keeps sensitive input inside the browser.</p>
            <p>We won’t publish thin pages just to look larger. New categories will become active only when there is a working, tested tool behind them.</p>
          </div>
        </div>
      </section>
    </>
  )
}
